/* eslint-disable no-process-env, eqeqeq, no-eq-null */
const { REACT_APP_ENV } = process.env;

export const filterProviders = (providers, isEu, _enableEuRegion) => {
  if (!providers) {
    return [{ cloudEnvironment: `aws-${REACT_APP_ENV}`, authType: 'LEGACY' }];
  }

  if (isEu || _enableEuRegion) {
    let filteredProviders = providers.filter((provider) =>
      provider.cloudEnvironment.includes('awseu'),
    );

    if (!filteredProviders.length) {
      filteredProviders = providers
        .filter((provider) => provider.cloudEnvironment.includes('aws-'))
        .map((provider) => {
          provider.cloudEnvironment = provider.cloudEnvironment.replace('aws-', 'awseu-');

          return provider;
        });
    }

    return filteredProviders;
  }

  return providers.filter((provider) => !provider.cloudEnvironment.includes('awseu'));
};

export const filterCloudEnvironments = (cloudEnvironments, isEu, _enableEuRegion) =>
  filterProviders(cloudEnvironments, isEu, _enableEuRegion).map(
    (provider) => provider.cloudEnvironment,
  );
